// ToggleTabs.jsx
import React from "react";

const ToggleTabs = ({ options = [], active, setActive }) => {
  return (
    <div className="flex items-center gap-1 bg-gray-100 p-1 rounded-lg w-fit mx-auto">
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => setActive(option.value)}
          className={`px-10 py-1.5 text-sm font-medium rounded-lg transition-all duration-200 ${active === option.value
            ? "bg-white text-[#504EFF] shadow-sm"
            : "text-gray-600 hover:text-gray-900"
            }`}
        >
          <p className="">{option.label}</p>
        </button>
      ))}
    </div>
  );
};

export default ToggleTabs;
